import { BannerConfig } from '../addi-product-banner/addi-product-banner.d';
import { Builder } from './content-builder.d';
import {
  BnplDefaultTemplate,
  BNPLWidgetProspectDiscount,
} from './templates/bnpl';
import { Template } from './templates/types';

const defaultBuilder: Builder = {
  build: BnplDefaultTemplate,
};

/**
 * Templates Notations
 * ADDI_[PRODUCTO]_[MODIFICADOR]
 */

const templateBuilder: { [key in Template]?: Builder } = {
  [Template.ADDI_BNPL_DEFAULT]: {
    build: BnplDefaultTemplate,
  },
  [Template.ADDI_BNPL_DEFAULT_LOCAL]: {
    build: BnplDefaultTemplate,
  },
  [Template.ADDI_BNPL_PROSPECT_DISCOUNT]: {
    build: BNPLWidgetProspectDiscount,
  },
  [Template.ADDI_BNPL_PROSPECT_DISCOUNT_LOCAL]: {
    build: BNPLWidgetProspectDiscount,
  },

  // To ensure backwards compatibility temporarily
  [Template.ADDI_TEMPLATE_01]: {
    build: BnplDefaultTemplate,
  },
  [Template.ADDI_TEMPLATE_01_LOCAL]: {
    build: BnplDefaultTemplate,
  },
  [Template.ADDI_TEMPLATE_NC_DISC]: {
    build: BNPLWidgetProspectDiscount,
  },
  [Template.ADDI_TEMPLATE_NC_DISC_LOCAL]: {
    build: BNPLWidgetProspectDiscount,
  },
};

export const bannerBuilder = (
  template: Template,
  config: BannerConfig
): HTMLElement => {
  const builder: Builder = templateBuilder[template] ?? defaultBuilder;

  return builder.build(config);
};
